import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  ViewChild,
} from '@angular/core';
import { map } from 'rxjs/operators';
import { UploadItem } from 'src/app/services/uploading/types/upload-item.type';
import { UploadingService } from 'src/app/services/uploading/uploading.service';
import { environment } from 'src/environments/environment';

import { UploadingListItem } from '../../../types/uploading-list-item.type';

@Component({
  selector: 'app-lot-add-photo-uploading-list-item-add',
  templateUrl: './lot-add-photo-uploading-list-item-add.component.html',
  styleUrls: ['./lot-add-photo-uploading-list-item-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoUploadingListItemAddComponent {
  @Output() uploadingItems = new EventEmitter<UploadingListItem[]>();

  @ViewChild('fileInput')
  fileInput: ElementRef<HTMLInputElement>;

  constructor(private readonly uploadingService: UploadingService) {}

  @HostListener('click')
  openFileDialog(): void {
    this.fileInput.nativeElement.click();
  }

  addUploadingItems(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files);
    const uploadingListItems = files
      .filter((file) => file.type.startsWith('image'))
      .map((file) => this.uploadingService.uploadFile(file))
      .map((uploadItem) => this.uploadItemToUploadingListItem(uploadItem));

    if (uploadingListItems.length) {
      this.uploadingItems.emit(uploadingListItems);
    }

    input.value = null;
  }

  private uploadItemToUploadingListItem(uploadItem: UploadItem): UploadingListItem {
    const { key$, status$, uploadingProgress$ } = uploadItem;
    const url$ = key$.pipe(
      map((key) => `https://img.${environment.domain}/${key}`),
      map((url) => url.replace('img.lots.loc/', 'img.twilight.link/')),
    );

    return {
      url$,
      status$,
      uploadingProgress$,
    } as any;
  }
}
